import React from "react";
import { twMerge } from "tailwind-merge";
import { Check, Square } from "lucide-react";

export interface FeatureCheckboxProps {
  id: string;
  title: string;
  description?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export const FeatureCheckbox: React.FC<FeatureCheckboxProps> = ({
  id,
  title,
  description,
  checked = false,
  onChange,
  disabled = false,
  className,
}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      id={id}
      onClick={handleClick}
      disabled={disabled}
      className={twMerge(
        "w-[310px] rounded-lg py-4 pl-4 pr-2 flex items-start gap-4 transition-colors duration-200",
        "border-2 border-chariot-stroke",
        checked && "border-chariot-brand-primary",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
    >
      {/* Checkbox */}
      {checked && (
        <div
          className={twMerge(
            "relative shrink-0 size-5 rounded-md",
            "flex items-center justify-center",
            "chariot-brand-primary bg-chariot-brand-primary"
          )}
        >
          <Check className={"size-3 text-white stroke-[3px]"} />
        </div>
      )}

      {!checked && (
        <Square className="size-5 shrink-0 stroke-[3px] text-chariot-stroke" />
      )}

      {/* Text content */}
      <div className="text-left">
        <p className="text-sm font-semibold text-chariot-text-primary">
          {title}
        </p>
        {description && (
          <p className="text-xs text-chariot-text-primary mt-0.5">
            {description}
          </p>
        )}
      </div>
    </button>
  );
};

export default FeatureCheckbox;
